export const GET_VISITS_REPORT = "GET_VISITS_REPORT";
export const GET_VISITS_REPORT_SUCCESS = "GET_VISITS_REPORT_SUCCESS";
export const GET_VISITS_REPORT_FAILURE = "GET_VISITS_REPORT_FAILURE";
